module.exports = __webpack_public_path__ + "img/plateform.1a2e6ff0.jpg";